import { useClickOutside } from '../hooks'
import * as React from 'react'
import { Col } from './flex'

interface ModalProps {
    children?: React.ReactNode
    className?: string
    onClose?: () => void
}

export const Modal = ({
    className,
    children,
    onClose = () => {},
}: ModalProps) => {
    const ref = React.useRef<HTMLDivElement>(null)
    useClickOutside(ref, onClose)

    return (
        <>
            <div className="fixed z-30 top-0 bottom-0 left-0 right-0 bg-black bg-opacity-50" />
            <Col className="fixed z-30 top-0 bottom-0 left-0 right-0">
                <Col
                    ref={ref}
                    className={`relative bg-white p-4 m-auto rounded ${
                        className ?? ''
                    }`}>
                    <button
                        className="absolute top-0 right-0 p-4"
                        onClick={onClose}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 transform rotate-45 text-gray-700"
                            viewBox="0 0 20 20"
                            fill="currentColor">
                            <path
                                fillRule="evenodd"
                                d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                    {children}
                </Col>
            </Col>
        </>
    )
}
